import Skeleton from "@/common/components/Skeleton";

interface NotificationsConfigurationsLoadingStateProps {
  rows?: number
}

const NotificationsConfigurationsLoadingState = ({ rows }: NotificationsConfigurationsLoadingStateProps) => {
  return (
    <div className="flex flex-col gap-4">
      {new Array(rows ?? 12).fill(null).map((_, i) => (
        <div key={`config_load_${i}`} className="flex items-center gap-2">
          <Skeleton width={Math.floor(Math.random() * (250 - 200 + 1)) + 200} height={26} className="bg-white-100" />

          <Skeleton width={Math.floor(Math.random() * (200 - 150 + 1)) + 150} height={26} className="bg-white-100" />
        </div>
      ))}
    </div>
  );
}

export default NotificationsConfigurationsLoadingState;
